const { translateString } = window.BAO.Utils

class CountryLookup extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.records = Array.from(this.els?.item?.elements || []).map((el) => ({
      el,
      name: this.normalise(el.dataset.countryName),
      iso: this.normalise(el.dataset.countryIso),
    }))

    this.filter('')

    const drawer = this.closest('dialog')
    if (!drawer) return

    this.observer = new MutationObserver(() => {
      if (drawer.hasAttribute('open')) {
        this.els?.input?.element?.focus()
      }
    })

    this.observer.observe(drawer, {
      attributes: true,
      attributeFilter: ['open'],
    })
  }

  setupListeners () {
    super.setupListeners()

    this.onInput = this.onInput.bind(this)
    this.onKeyDown = this.onKeyDown.bind(this)

    const input = this.els.input.element
    input.addEventListener('input', this.onInput)
    input.addEventListener('keydown', this.onKeyDown)
  }

  onInput (event) {
    this.filter(event.target.value)
  }

  onKeyDown (event) {
    if (event.key !== 'Escape') return

    const input = this.els.input.element

    if (input.value) {
      event.preventDefault()
      event.stopPropagation()

      input.value = ''
      this.filter('')
    }
  }

  filter (value = '') {
    const query = this.normalise(value)
    const hasQuery = query.length > 0
    let visibleCount = 0

    this.records.forEach((item) => {
      const isMatch =
        !hasQuery || item.name.includes(query) || item.iso.startsWith(query)

      item.el.hidden = !isMatch
      if (isMatch) visibleCount++
    })

    if (this.els['no-results']?.exists) {
      this.els['no-results'].element.innerHTML = translateString(
        this.translations?.localization?.noResults,
        {
          query: `${query}`,
        },
      )

      this.els['no-results'].element.setAttribute(
        'aria-hidden',
        visibleCount > 0 ? 'true' : 'false',
      )
    }
  }

  normalise (value = '') {
    return String(value).trim().toLowerCase()
  }

  get translations () {
    return window.theme?.strings ?? {}
  }
}

if (!customElements.get('country-lookup')) {
  customElements.define('country-lookup', CountryLookup)
}
